import { IAction } from '~/src/store';

import { EPaymentActions } from './index';

export type TSetBonusesValueValidity = IAction<EPaymentActions.SET_BONUSES_VALUE_VALIDATION, boolean>

const setBonusesValueValidity = (isValid: boolean): TSetBonusesValueValidity => ({
    type: EPaymentActions.SET_BONUSES_VALUE_VALIDATION,
    payload: isValid,
});

export default setBonusesValueValidity;
